const defaultState = {
	sqlIds: [],
	fullSqlIds: [],
	menuTree: [],
	searchText: '',
	searchParams: {
		sqlId: '',
		sqlParameters: [],
		sqlText: ''
	},
	sqlContent: [],
	selectedContent: {},
	cSharpServiceUrls: [
		{ label: 'SFCC', value: 'SFCC' },
		{ label: 'VPRS', value: 'VPRS' },
		{ label: 'VPQ', value: 'VPQ' },
		{ label: 'VPP', value: 'VPP' },
		{ label: 'VPO', value: 'VPO' },
		{ label: 'VPE', value: 'VPE' }
	],
	javaServiceUrls: [{ label: 'SFCC', value: 'SFCC' }],
	serviceUrl: null,
	servicePrograms: [
		{ label: 'Java', value: 'Java' },
		{ label: 'CSharp', value: 'CSharp' }
	],
	serviceProgram: null,
	popupParams: {
		show: false,
		result: {}
	},
	columns: [],
	xmlData: [],
	pagingInfo: {
		currentPage: 1,
		pageUnit: 30
	}
};
export default {
	...JSON.parse(JSON.stringify(defaultState))
};
export { defaultState };
